import { createSlice } from '@reduxjs/toolkit';

export const retailerSlice = createSlice({
  name: 'retailer',
  initialState: {
    retailerId: null,
    retailerRecords: null
  },
  reducers: {
    pushRetailerId: (state, action) => {
      state.retailerId = action.payload;
    },
    popRetailerId: (state) => {
      state.retailerId = null;
    },
    pushRetailerRecords: (state, action) => {
      state.retailerRecords = action.payload;
    },
    popRetailerRecords: (state) => {
      state.retailerRecords = null
    }
  },
});

export const { pushRetailerId, popRetailerId, pushRetailerRecords, popRetailerRecords } = retailerSlice.actions;

export const selectRetailerId = (state) => state.retailer.retailerId;

export const selectRetailerRecords = (state) => state.retailer.retailerRecords;

export default retailerSlice.reducer;
